import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export interface SidebarMenuItem {
  id?: string;
  name: string;
  route: string;
  icon?: string;
  nameTraslate: string;
  subItems?: SidebarMenuItem[];
}

@Injectable({
  providedIn: 'root',
})
export class MenuService {
  private readonly menuItems = new BehaviorSubject<SidebarMenuItem[]>([]);

  public home = {
    name: $localize`Inicio`,
    id: '',
    route: 'home',
    nameTraslate: '',
  };

  public manageStatements = {
    name: $localize`Administrar declaraciones`,
    id: '',
    route: 'manage-statements',
    nameTraslate: '',
  };

  public statementAssignment = {
    name: $localize`Asignación de declaraciones`,
    id: '',
    route: 'statement-assignment',
    nameTraslate: '',
  };

  public templates = {
    name: $localize`Plantillas`,
    id: '',
    route: 'templates',
    nameTraslate: '',
  };

  public declarantDashboard = {
    name: $localize`Inicio`,
    id: '',
    route: 'dashboard',
    nameTraslate: '',
  };

  public myDeclarations = {
    name: $localize`Mis declaraciones`,
    id: '',
    route: 'my-declarations',
    nameTraslate: '',
  };

  public reviewerDashboard = {
    name: $localize`Inicio`,
    id: '',
    route: 'dashboard',
    nameTraslate: '',
  };

  public reviews = {
    name: $localize`Revisiones`,
    id: '',
    route: 'reviews',
    nameTraslate: '',
  };

  public rhDashboard = {
    name: $localize`Inicio`,
    id: '',
    route: 'dashboard',
    nameTraslate: '',
  };

  public users = {
    name: $localize`Usuarios`,
    id: '',
    route: 'users',
    nameTraslate: '',
  };

  public reports = {
    name: $localize`Reportes`,
    id: '',
    route: 'report',
    nameTraslate: '',
  };

  public adminUser = [
    this.home,
    this.manageStatements,
    this.statementAssignment,
    this.templates,
  ];

  public declarantUser = [this.declarantDashboard, this.myDeclarations];

  public reviewerUser = [this.home, this.reviews];

  public rhUser = [this.rhDashboard, this.users, this.reports];

  getMenuItems() {
    return this.menuItems.asObservable();
  }

  setMenuItems(currentUser: string) {
    switch (currentUser) {
      case 'administrator':
        this.menuItems.next(this.adminUser);
        break;
      case 'declarant':
        this.menuItems.next(this.declarantUser);
        break;
      case 'reviewer':
        this.menuItems.next(this.reviewerUser);
        break;
      case 'rrhh':
        this.menuItems.next(this.rhUser);
        break;

      default:
        break;
    }
  }
}
